import {
   ICONS_MAP,
   LABEL_MAP,
} from '@forwardflow/constants/onboarding.constants'
import { IFilterCriteria } from '@forwardflow/types/onboarding'
import { Group } from '@forwardflow/ui-v2'

const FilterDefinition = ({
   filterCriteria,
}: {
   filterCriteria: IFilterCriteria
}) => {
   return (
      <Group>
         <p className="rounded-[8px] bg-[#9F7BFF]/10 px-3 py-1.5 font-medium flex items-center gap-2">
            {filterCriteria?.field &&
               ICONS_MAP[filterCriteria.field as keyof typeof ICONS_MAP]}
            {filterCriteria?.field &&
               LABEL_MAP[filterCriteria.field as keyof typeof LABEL_MAP]}
         </p>
         <Group>
            {filterCriteria?.value.map((value, index) => (
               <p
                  key={index}
                  className="rounded-[8px] text-white border border-[#A684FF]/30 bg-[#A684FF]/10 px-6 py-1"
               >
                  {value}
               </p>
            ))}
         </Group>
      </Group>
   )
}

export default FilterDefinition
